export var TargetType;
(function (TargetType) {
    TargetType["HORSE"] = "horse";
    TargetType["DOG"] = "dog";
    TargetType["CAT"] = "cat";
    TargetType["HUMAN"] = "human";
})(TargetType || (TargetType = {}));
//# sourceMappingURL=TargetType.js.map